import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Spin } from "antd";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import styles from "./IndividuIntroduccio.module.css";
import IndividuFormulari from "./IndividuFormulari";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import {
  getIdIndividuLlista,
  getPeticioEnviarFormulariIndividuEnCurs
} from "../../reducers";
import {
  individuIntroduccioDescartarCanvis,
  individuIntroduccioEnviarFormulari
} from "../../actions";
import { rutaIndividus, rutaDetallIndividu } from "../../routes";

class IndividuIntroduccio extends Component {
  generarBotoCancelar() {
    const {
      idIndividu,
      peticioEnviarFormulariEnCurs,
      individuIntroduccioDescartarCanvis
    } = this.props;

    const ruta = idIndividu === null ? rutaIndividus : rutaDetallIndividu;
    const onClick = individuIntroduccioDescartarCanvis;

    return (
      <Link to={ruta}>
        <Button
          size="large"
          disabled={peticioEnviarFormulariEnCurs}
          onClick={onClick}
        >
          Cancel·lar
        </Button>
      </Link>
    );
  }

  render() {
    const {
      history,
      peticioEnviarFormulariEnCurs,
      individuIntroduccioEnviarFormulari
    } = this.props;

    const botoCancelar = this.generarBotoCancelar();

    return (
      <Spin
        spinning={peticioEnviarFormulariEnCurs}
        delay={RETARD_MILISEGONS_APARICIO_SPINNER}
      >
        <div className={styles.individuIntroduccioDetall}>
          <div className={styles.individuIntroduccioDetallContenidor}>
            <IndividuFormulari esEditable={true} />
          </div>
          <div className={styles.individuIntroduccioDetallBotons}>
            <Button
              type="primary"
              size="large"
              disabled={peticioEnviarFormulariEnCurs}
              onClick={() => individuIntroduccioEnviarFormulari(history)}
            >
              Guardar
            </Button>
            {botoCancelar}
          </div>
        </div>
      </Spin>
    );
  }
}

IndividuIntroduccio.propTypes = {
  idIndividu: PropTypes.number,
  peticioEnviarFormulariEnCurs: PropTypes.bool,
  individuIntroduccioDescartarCanvis: PropTypes.func,
  individuIntroduccioEnviarFormulari: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    idIndividu: getIdIndividuLlista(state),
    peticioEnviarFormulariEnCurs: getPeticioEnviarFormulariIndividuEnCurs(state)
  };
};

const mapDispatchToProps = {
  individuIntroduccioDescartarCanvis,
  individuIntroduccioEnviarFormulari
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(IndividuIntroduccio)
);
